import { makeAutoObservable, runInAction } from "mobx";
import { Store, AllAlarmsData, IAlarmStore, AlarmEventsData, AlarmDetails } from "../global/types";
import { getAlarmDetails, getAllAlarmsData } from "../api/user.action"

class AlarmStore implements IAlarmStore {
    rootStore: Store;
    allAlarmsData: AllAlarmsData[] = [];
    alarmsData: AllAlarmsData | null = null;
    alarmDetails: AlarmDetails | null = null; 
    alarmEventsData: AlarmEventsData[] = []
    error: string | null = null;
    loading: boolean = false;
    page: number = 1;
    searchTerm: string = '';
    limit: number = 10;
    totalItems: number = 0;
    totalPages: number = 0;
    customerId: string = '';

    constructor(rootStore: Store) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setLoading = (loading: boolean) => {
        this.loading = loading;
    }

    fetchAllAlarmsData = async (
        action: 'change_page' | 'search' | 'change_limit' | 'change_filter' | '',
        page: number,
        searchTerm: string,
        limit: number
    ) => {
        this.setLoading(true);
        try {
            runInAction(() => {
                switch (action) {
                    case 'change_page':
                        this.page = page;
                        break;
                    case 'search':
                        this.searchTerm = searchTerm;
                        this.page = 1;
                        break;
                    case 'change_limit':
                        this.limit = limit
                        this.page = 1
                        break;
                    default:
                        break;
                }
            })
            const data = {
                page: this.page,
                limit: this.limit,
                search: this.searchTerm?.trim()
            }
            const response = await getAllAlarmsData(data);
            runInAction(() => {
                this.allAlarmsData = response.data?.alarms || [];
                this.totalItems = response.data?.totalItems;
                this.totalPages = response.data?.totalPages;
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    fetchAlarmDetails = async(id: string) => {
        this.setLoading(true);
        try {
            const response = await getAlarmDetails(id)
            runInAction(() => {
                this.alarmDetails = response.data?.data || [];
                this.alarmEventsData= response.data?.data?.alarm_events || []
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    fetchOneAlarmData = async (id: string) => {
        this.setLoading(true);
        try {
            
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    resetAlarmPageDataStates = () => {
        runInAction(() => {
            this.allAlarmsData = [];
            this.alarmsData = null;
            this.error = null;
            this.loading = false;
            this.page = 1;
            this.searchTerm = '';
            this.limit = 10;
            this.totalItems = 0;
            this.totalPages = 0;
            this.customerId = '';
        })
    }
}

export default AlarmStore;
